/* src/app/components/dialogs/select-sort/select-sort.component.scss */
mat-dialog-content {
  padding: 24px;
}
mat-dialog-content div {
  display: flex;
}
mat-form-field:first-child {
  margin-right: 12px;
  flex: auto;
}
mat-form-field:last-child {
  margin-left: 12px;
}
/*# sourceMappingURL=select-sort.component.css.map */
